import { useParams } from 'react-router-dom';
import { SquareConnectLogo } from '../components/Logo/SquareConnectLogo';

export enum ConnectIntegrationType {
  SQUARE = 'square',
}

const IntegrationHeaderContents = {
  [ConnectIntegrationType.SQUARE]: {
    name: ConnectIntegrationType.SQUARE,
    logo: SquareConnectLogo,
    title: 'Manage Square Accounts',
    subtitle: 'Securely connect your Square account with Kickfin! Once connected, your Kickfin sites will have the ability use on your Square data!',
    error: {
      title: 'Account Access Denied',
      subtitle: 'You have denied Kickfin access to your Square account. If you did this in error you can repeat the process to grant Kickfin access. Click Continue to return to the Square connection management page.',
    },
  },
};

const useConnectIntegration = () => {
  const { integration } = useParams<{ integration: ConnectIntegrationType }>();

  return IntegrationHeaderContents[integration];
};

export default useConnectIntegration;
